import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Title from "../Title";
import axios from "axios";
import moment from "moment-timezone";
import { nowOperationalDateString } from "../../utils/operationalDateTime";


interface MyModalProps {
  isOpenAbono: boolean;
  onCloseAbono: () => void;
  onButtonClickAbono: () => void;
  id: string;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  height: 210,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 2,
  p: 4,
};

const ModalAbonos: React.FC<MyModalProps> = ({
  isOpenAbono,
  onCloseAbono,
  onButtonClickAbono,
  id,
}) => {
  const [lends, setLends] = useState([]);
  const [lendpay, setLendpay] = useState([]);

  const [idnumber, setIdnumber] = useState("");
  const [fullname, setFullname] = useState("");
  const [cellphone, setCellphone] = useState("");
  const [mainaddress, setMainaddress] = useState("");

  const [date, setDate] = useState("");
  const [fecha, setFecha] = useState("");
  const [value, setValue] = useState("");
  const [total_value, setTotal_value] = useState("");
  const [daily_pay_value, setDaily_pay_value] = useState("");
  const [days_term, setDays_term] = useState("");
  const [abono, setAbono] = useState("");
  const aboNum = parseInt(abono);
  const totalNum = parseInt(total_value);
  const pendiente = totalNum - aboNum;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const lendpayData = await axios.get(`lendpay/${id}`);
        //console.log("pagos lendpay", lendpayData.data);
        setLendpay(lendpayData.data);
      } catch (error) {
        console.error("Error fetching lendpay data:", error);
      }
    };

    const fetchData2 = async () => {
      try {
        const lendsData = await axios.get(`lends/${id}`);
        //console.log("pagos lends", lendsData.data);

        setLends(lendsData.data);
        setLends(lendsData.data);
        setIdnumber(lendsData.data.client.idnumber);
        setFullname(lendsData.data.client.fullname);
        setCellphone(lendsData.data.client.cellphone);
        setMainaddress(lendsData.data.client.mainaddress);
        setDate(lendsData.data.date);
        setValue(lendsData.data.value);
        setTotal_value(lendsData.data.total_value);
        setDaily_pay_value(lendsData.data.daily_pay_value);
        setDays_term(lendsData.data.days_term);
      } catch (error) {
        console.error("Error fetching lends data:", error);
      }
    };

    if (isOpenAbono) {
      fetchData();
      fetchData2();
    }
  }, [isOpenAbono, id]);

  return (
    <Modal
      hideBackdrop
      open={isOpenAbono}
      onClose={onCloseAbono}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Title>Modificar Abono {idnumber}</Title>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="date"
              label="Fecha de inicio actual"
              id="idnumber"
              value={date}
              onChange={(event) => setDate(event.target.value)}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="date"
              label="Nueva Fecha"
              value={fecha || " "}
              onChange={(event) => setFecha(event.target.value)}
              InputLabelProps={{ shrink: true }}
              inputProps={{ max: nowOperationalDateString() }}
            />
          </Grid>
        </Grid>
        <Button
          variant="contained"
          onClick={onButtonClickAbono}
          style={{
            position: "absolute",
            bottom: 16,
            right: 16,
            color: "white",
          }}
        >
          Cerrar
        </Button>
      </Box>
    </Modal>
  );
};

export default ModalAbonos;
